import { render } from "./ThePriceCompetitorMain.vue?vue&type=template&id=25f25cb3"
import script from "./ThePriceCompetitorMain.vue?vue&type=script&lang=js"
export * from "./ThePriceCompetitorMain.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__